import { makeStyles } from '@material-ui/core'

export default makeStyles(() => ({
  disabledEditor: {
    '& *': {
      color: '#bdbdbd !important',
    },
  },
}))
